/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		"main": 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + "." + {"conditioner0":"c258c53e38e235b156f6","unfetch":"ee4d18f18dd615bb7707","conditioner4":"cd0bf50789fd4362fb8b","ReCaptcha.js_ReCaptchaInstance.js_ReCaptchaLoader.js":"37a7e0573b392f0c9c26","conditioner6":"47096031ab6fade1db16"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/themes/default/dist/js/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/js/main.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/@parallaxagency/conditioner/dist/index.mjs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return u; });
/* unused harmony export saveData */
/* unused harmony export visible */
/* unused harmony export connection */
/* unused harmony export screen */
/* unused harmony export scroll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_compute_scroll_into_view__ = __webpack_require__("./node_modules/compute-scroll-into-view/es/index.js");
var e = function e() {
  return +new Date();
},
    n = "function" == typeof requestIdleCallback,
    o = function o(t) {
  this.initTime_ = t;
},
    r = { didTimeout: { configurable: !0 } };r.didTimeout.get = function () {
  return !1;
}, o.prototype.timeRemaining = function () {
  return Math.max(0, 50 - (e() - this.initTime_));
}, Object.defineProperties(o.prototype, r);var i = n ? requestIdleCallback : function (t) {
  var n = new o(e());return setTimeout(function () {
    return t(n);
  }, 0);
},
    a = n ? cancelIdleCallback : function (t) {
  clearTimeout(t);
},
    u = { monitor: { name: "idle", create: function create() {
      return { matches: !1, addListener: function addListener(t) {
          var e = this;this.handle = i(function () {
            e.matches = !0, t();
          });
        }, removeListener: function removeListener() {
          this.handle && a(this.handle);
        } };
    } } },
    c = { monitor: { name: "savedata", create: function create() {
      var t = navigator.connection || navigator.mozConnection || navigator.webkitConnection;return { matches: !!t && t.saveData, addListener: function addListener(e) {
          var n = this;t && (this.onChange = function () {
            n.matches = t && t.saveData, e();
          }, t.addEventListener("change", this.onChange));
        }, removeListener: function removeListener() {
          t && t.removeEventListener("change", this.onChange);
        } };
    } } },
    s = { monitor: { name: "visible", create: function create(t, e) {
      return { matches: !1, addListener: function addListener(n) {
          var o = this;"IntersectionObserver" in window ? (this.observer = new window.IntersectionObserver(function (e) {
            o.matches = e.pop().isIntersecting == t, n();
          }, { threshold: e.hasAttribute("data-threshold") ? parseFloat(e.getAttribute("data-threshold")) : 0 }), this.observer.observe(e)) : (this.matches = !e.hasAttribute("data-fallback") || "enable" === e.getAttribute("data-fallback"), n());
        }, removeListener: function removeListener() {
          this.observer && this.observer.disconnect();
        } };
    } } },
    l = ["slow-2g", "2g", "3g", "4g"],
    f = { monitor: { name: "connection", create: function create(t, e) {
      if (-1 === l.indexOf(t)) throw new Error("Invalid connection type: " + t);var n = navigator.connection || navigator.mozConnection || navigator.webkitConnection;return { matches: d(n || { effectiveType: e.dataset.connection || "4g" }, t), addListener: function addListener(e) {
          var o = this;n && (this.onChange = function () {
            o.matches = n ? d(n, t) : fallback, e();
          }, n.addEventListener("change", this.onChange));
        }, removeListener: function removeListener() {
          n && n.removeEventListener("change", this.onChange);
        } };
    } } };function d(t, e) {
  return t && l.indexOf(t.effectiveType) >= l.indexOf(e);
}function m(t) {
  return { monitor: { name: "screen", create: function create(e) {
        var n = e.split(/\s+/),
            o = n.pop(),
            r = function (t) {
          return (Array.isArray(t) ? t : [t]).map(function (t) {
            return "string" == typeof t ? "(min-width: " + t + ")" : Object.keys(t).map(function (e) {
              return "raw" === e ? t[e] : "(" + e + "-width: " + t[e] + ")";
            }).join(" and ");
          }).join(", ");
        }(t[o]);return "not" === n[0] && (r = "not all and " + r), window.matchMedia(r);
      } } };
}var h = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';function v(e, n) {
  void 0 === n && (n = {});var o = n.scrollMode;void 0 === o && (o = "if-needed");var r = n.block;void 0 === r && (r = "start");var i = n.inline;void 0 === i && (i = "nearest");var a = n.offset;void 0 === a && (a = 0);var u = n.smooth;void 0 === u && (u = "true");var c = n.history;function s(n) {
    var s = e.getAttribute("href"),
        l = document.querySelector(s);if (!l) throw new Error("Couldn’t find element for href " + s);n.preventDefault();var f = "matchMedia" in window && window.matchMedia("(prefers-reduced-motion: reduce)").matches,
        d = "true" !== u || f ? "auto" : "smooth";"none" !== c && window.history[c + "State"]({}, "", s);var m = Object(__WEBPACK_IMPORTED_MODULE_0_compute_scroll_into_view__["a" /* default */])(l, { scrollMode: o, block: r, inline: i });if (m.length) {
      var v = document.querySelector("[data-scroll-offset]");v && (a += v.offsetHeight);
    }var p = function (t, e) {
      return t.matches ? t.matches(e) : t.msMatchesSelector ? t.msMatchesSelector(e) : t.webkitMatchesSelector ? t.webkitMatchesSelector(e) : void 0;
    }(l, h) ? [l] : l.querySelectorAll(h);p.length && (m.forEach(function (t) {
      t.originalTop = t.el.scrollTop, t.originalLeft = t.el.scrollLeft;
    }), p[0].focus(), m.forEach(function (t) {
      t.el.scrollTop = t.originalTop;
    })), m.forEach(function (t) {
      var e = t.el,
          n = t.top,
          o = t.left;try {
        e.scroll({ top: n - a, left: o, behavior: d });
      } catch (t) {
        e.scrollTop = n - a, e.scrollLeft = o;
      }
    });
  }return void 0 === c && (c = "none"), e.addEventListener("click", s), function () {
    return e.removeEventListener("click", s);
  };
}var p = /(was|initial)? ?(not)? ?@([a-z]+) ?(.*)?/,
    g = /(?:was |initial )?(?:not )?@[a-z]+ ?.*?(?:(?= and (?:was )?(?:not )?@[a-z])|$)/g,
    w = function w(t) {
  return void 0 === t || "true" === t || "false" !== t && t;
},
    b = function b(t) {
  var e = t.match(p),
      n = e[1],
      o = e[2];return [e[3], w(e[4]), "not" === o, "was" === n, "initial" === n];
},
    y = function y(t, e, n) {
  var o = function (t, n) {
    for (var o = 0; o < t.length; o++) {
      if (t[o].name === e) return t[o];
    }
  }(S("monitor"));if (!o) throw new Error('Conditioner: Cannot find monitor with name "@' + e + '". Only the "@media" monitor is always available. Custom monitors can be added with the `addPlugin` method using the `monitors` key. The name of the custom monitor should not include the "@" symbol.');return o.create(n, t);
},
    C = function C(t, e) {
  var n = { matches: !1, active: !1, onchange: function onchange() {}, start: function start() {
      n.active || (n.active = !0, o.forEach(function (t) {
        return t.forEach(function (t) {
          t.initial || t.addListener(r);
        });
      }), r());
    }, stop: function stop() {
      n.active = !1, o.forEach(function (t) {
        return t.forEach(function (t) {
          t.removeListener && t.removeListener(r);
        });
      });
    }, destroy: function destroy() {
      n.stop(), o.length = 0;
    } },
      o = t.split(" or ").map(function (t) {
    return (n = t, n.match(g).map(b)).map(function (t) {
      return function (t, e, n, o) {
        return t.invert = e, t.retain = n, t.initial = o, t.matched = !1, t;
      }.apply(void 0, [y.apply(void 0, [e].concat(t))].concat(t.splice(2)));
    });var n;
  }),
      r = function r() {
    var t = o.reduce(function (t, e) {
      return !!t || e.reduce(function (t, e) {
        if (!t) return !1;var n = e.invert ? !e.matches : e.matches;return n && (e.matched = !0), !(!e.retain || !e.matched) || n;
      }, !0);
    }, !1);n.matches = t, n.onchange(t);
  };return n;
},
    L = function L(t) {
  var e = function (t) {
    var e = M("moduleGetName", t),
        n = x("moduleSetName", e),
        o = { destruct: null, mounting: !1 },
        r = { alias: e, name: n, element: t, mounted: !1, unmount: function unmount() {
        o.destruct && r.mounted && (T("moduleWillUnmount", r), o.destruct(), r.mounted = !1, T("moduleDidUnmount", r), r.onunmount.apply(t));
      }, mount: function mount() {
        if (!r.mounted && !o.mounting) return T("moduleWillMount", r), M("moduleImport", n).catch(function (e) {
          throw o.mounting = !1, T("moduleDidCatch", e, r), r.onmounterror.apply(t, [e, r]), new Error("Conditioner: " + e);
        }).then(function (e) {
          o.destruct = M("moduleGetDestructor", M("moduleGetConstructor", e).apply(void 0, M("moduleSetConstructorArguments", n, t))), r.mounted = !0, o.mounting = !1, T("moduleDidMount", r), r.onmount.apply(t, [r]);
        }), r;
      }, onmounterror: function onmounterror() {}, onmount: function onmount() {}, onunmount: function onunmount() {}, destroy: function destroy() {} };return r;
  }(t),
      n = M("moduleGetContext", t);return n ? function (t, e) {
    var n = C(t, e.element);return n.onchange = function (t) {
      return t ? e.mount() : e.unmount();
    }, n.start(), e;
  }(n, e) : e.mount();
},
    k = [],
    E = function E(t) {
  return k.push(t);
},
    S = function S(t) {
  return k.filter(function (e) {
    return Object.keys(e).indexOf(t) > -1;
  }).map(function (e) {
    return e[t];
  });
},
    T = function T(t) {
  for (var e = [], n = arguments.length - 1; n-- > 0;) {
    e[n] = arguments[n + 1];
  }return S(t).forEach(function (t) {
    return t.apply(void 0, e);
  });
},
    x = function x(t) {
  for (var e = [], n = arguments.length - 1; n-- > 0;) {
    e[n] = arguments[n + 1];
  }return S(t).reduce(function (t, e) {
    return [e.apply(void 0, t)];
  }, e).shift();
},
    M = function M(t) {
  for (var e = [], n = arguments.length - 1; n-- > 0;) {
    e[n] = arguments[n + 1];
  }return S(t).pop().apply(void 0, e);
};E({ moduleSelector: function moduleSelector(t) {
    return t.querySelectorAll("[data-module]");
  }, moduleGetContext: function moduleGetContext(t) {
    return t.dataset.context;
  }, moduleImport: function moduleImport(t) {
    return new Promise(function (e, n) {
      if (self[t]) return e(self[t]);n('Cannot find module with name "' + t + '". By default Conditioner will import modules from the global scope, make sure a function named "' + t + '" is defined on the window object. The scope of a function defined with `let` or `const` is limited to the <script> block in which it is defined.');
    });
  }, moduleGetConstructor: function moduleGetConstructor(t) {
    return t;
  }, moduleGetDestructor: function moduleGetDestructor(t) {
    return t;
  }, moduleSetConstructorArguments: function moduleSetConstructorArguments(t, e) {
    var n = {};for (var o in e.dataset) {
      var r = e.dataset[o],
          i = r.toLowerCase();if ("true" === i) n[o] = !0;else if ("false" === i) n[o] = !1;else try {
        n[o] = JSON.parse(r);
      } catch (t) {
        n[o] = r;
      }
    }for (var a = {}, u = e.querySelectorAll("[data-ref]"), c = 0; c < u.length; c++) {
      var s = u[c],
          l = s.dataset.ref;a[l] ? a[l].push(s) : a[l] = [s];
    }return n.$refs = a, [e, n];
  }, moduleGetName: function moduleGetName(t) {
    return t.dataset.module;
  }, monitor: { name: "media", create: function create(t) {
      return self.matchMedia(t);
    } } });/* harmony default export */ __webpack_exports__["a"] = ({ monitor: C, hydrate: function hydrate(t) {
    return [].slice.call(M("moduleSelector", t)).map(L);
  }, addPlugin: E });
//# sourceMappingURL=index.mjs.map

/***/ }),

/***/ "./node_modules/compute-scroll-into-view/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isElement(el) {
  return el != null && typeof el === 'object' && el.nodeType === 1;
}

function canOverflow(overflow, skipOverflowHiddenElements) {
  if (skipOverflowHiddenElements && overflow === 'hidden') {
    return false;
  }

  return overflow !== 'visible' && overflow !== 'clip';
}

function isScrollable(el, skipOverflowHiddenElements) {
  if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
    var style = getComputedStyle(el, null);
    return canOverflow(style.overflowY, skipOverflowHiddenElements) || canOverflow(style.overflowX, skipOverflowHiddenElements);
  }

  return false;
}

function alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
  if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) {
    return 0;
  }

  if (elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize || elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize) {
    return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
  }

  if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) {
    return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
  }

  return 0;
}

/* harmony default export */ __webpack_exports__["a"] = (function (target, options) {
  var scrollMode = options.scrollMode,
      block = options.block,
      inline = options.inline,
      boundary = options.boundary,
      skipOverflowHiddenElements = options.skipOverflowHiddenElements;
  var checkBoundary = typeof boundary === 'function' ? boundary : function (node) {
    return node !== boundary;
  };

  if (!isElement(target)) {
    throw new TypeError('Invalid target');
  }

  var scrollingElement = document.scrollingElement || document.documentElement;
  var frames = [];
  var cursor = target;

  while (isElement(cursor) && checkBoundary(cursor)) {
    cursor = cursor.parentNode;

    if (cursor === scrollingElement) {
      frames.push(cursor);
      break;
    }

    if (cursor === document.body && isScrollable(cursor) && !isScrollable(document.documentElement)) {
      continue;
    }

    if (isScrollable(cursor, skipOverflowHiddenElements)) {
      frames.push(cursor);
    }
  }

  var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
  var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
  var viewportX = window.scrollX || pageXOffset;
  var viewportY = window.scrollY || pageYOffset;

  var _target$getBoundingCl = target.getBoundingClientRect(),
      targetHeight = _target$getBoundingCl.height,
      targetWidth = _target$getBoundingCl.width,
      targetTop = _target$getBoundingCl.top,
      targetRight = _target$getBoundingCl.right,
      targetBottom = _target$getBoundingCl.bottom,
      targetLeft = _target$getBoundingCl.left;

  var targetBlock = block === 'start' || block === 'nearest' ? targetTop : block === 'end' ? targetBottom : targetTop + targetHeight / 2;
  var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft;
  var computations = [];

  for (var index = 0; index < frames.length; index++) {
    var frame = frames[index];

    var _frame$getBoundingCli = frame.getBoundingClientRect(),
        _height = _frame$getBoundingCli.height,
        _width = _frame$getBoundingCli.width,
        _top = _frame$getBoundingCli.top,
        right = _frame$getBoundingCli.right,
        bottom = _frame$getBoundingCli.bottom,
        _left = _frame$getBoundingCli.left;

    if (scrollMode === 'if-needed' && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= _top && targetBottom <= bottom && targetLeft >= _left && targetRight <= right) {
      return computations;
    }

    var frameStyle = getComputedStyle(frame);
    var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
    var borderTop = parseInt(frameStyle.borderTopWidth, 10);
    var borderRight = parseInt(frameStyle.borderRightWidth, 10);
    var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
    var blockScroll = 0;
    var inlineScroll = 0;
    var scrollbarWidth = 'offsetWidth' in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
    var scrollbarHeight = 'offsetHeight' in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;

    if (scrollingElement === frame) {
      if (block === 'start') {
        blockScroll = targetBlock;
      } else if (block === 'end') {
        blockScroll = targetBlock - viewportHeight;
      } else if (block === 'nearest') {
        blockScroll = alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
      } else {
        blockScroll = targetBlock - viewportHeight / 2;
      }

      if (inline === 'start') {
        inlineScroll = targetInline;
      } else if (inline === 'center') {
        inlineScroll = targetInline - viewportWidth / 2;
      } else if (inline === 'end') {
        inlineScroll = targetInline - viewportWidth;
      } else {
        inlineScroll = alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
      }

      blockScroll = Math.max(0, blockScroll + viewportY);
      inlineScroll = Math.max(0, inlineScroll + viewportX);
    } else {
      if (block === 'start') {
        blockScroll = targetBlock - _top - borderTop;
      } else if (block === 'end') {
        blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
      } else if (block === 'nearest') {
        blockScroll = alignNearest(_top, bottom, _height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
      } else {
        blockScroll = targetBlock - (_top + _height / 2) + scrollbarHeight / 2;
      }

      if (inline === 'start') {
        inlineScroll = targetInline - _left - borderLeft;
      } else if (inline === 'center') {
        inlineScroll = targetInline - (_left + _width / 2) + scrollbarWidth / 2;
      } else if (inline === 'end') {
        inlineScroll = targetInline - right + borderRight + scrollbarWidth;
      } else {
        inlineScroll = alignNearest(_left, right, _width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
      }

      var scrollLeft = frame.scrollLeft,
          scrollTop = frame.scrollTop;
      blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - _height + scrollbarHeight));
      inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - _width + scrollbarWidth));
      targetBlock += scrollTop - blockScroll;
      targetInline += scrollLeft - inlineScroll;
    }

    computations.push({
      el: frame,
      top: blockScroll,
      left: inlineScroll
    });
  }

  return computations;
});

/***/ }),

/***/ "./node_modules/lazysizes/lazysizes.js":
/***/ (function(module, exports) {

(function(window, factory) {
	var lazySizes = factory(window, window.document);
	window.lazySizes = lazySizes;
	if(typeof module == 'object' && module.exports){
		module.exports = lazySizes;
	}
}(typeof window != 'undefined' ?
      window : {}, function l(window, document) {
	'use strict';
	/*jshint eqnull:true */

	var lazysizes, lazySizesCfg;

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 0,
			throttleDelay: 125,
		};

		lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesCfg)){
				lazySizesCfg[prop] = lazySizesDefaults[prop];
			}
		}
	})();

	if (!document || !document.getElementsByClassName) {
		return {
			init: function () {},
			cfg: lazySizesCfg,
			noSupport: true,
		};
	}

	var docElem = document.documentElement;

	var Date = window.Date;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	var addEventListener = window[_addEventListener];

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('Event');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initEvent(name, !noBubbles, !noCancelable);

		event.detail = detail;

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
			if(full && full.src && !el[_getAttribute]('srcset')){
				el.setAttribute('srcset', full.src);
			}
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = lazySizesCfg.throttleDelay;
		var rICTimeout = lazySizesCfg.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && rICTimeout > 49 ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesCfg.ricTimeout){
					rICTimeout = lazySizesCfg.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || delay < 9){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isVisible = function (elem) {
			if (isBodyHidden == null) {
				isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
			}

			return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = isVisible(elem);

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
				beforeExpandVal, defaultExpand, preloadExpand, hFac;
			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if (!defaultExpand) {
						defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
							docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
							lazySizesCfg.expand;

						lazysizes._defEx = defaultExpand;

						preloadExpand = defaultExpand * lazySizesCfg.expFactor;
						hFac = lazySizesCfg.hFac;
						isBodyHidden = null;

						if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
							currentExpand = preloadExpand;
							lowRuns = 0;
						} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
							currentExpand = defaultExpand;
						} else {
							currentExpand = shrinkExpand;
						}
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			var elem = e.target;

			if (elem._lazyCache) {
				delete elem._lazyCache;
				return;
			}

			resetPreloading(e);
			addClass(elem, lazySizesCfg.loadedClass);
			removeClass(elem, lazySizesCfg.loadingClass);
			addRemoveLoadEvents(elem, rafSwitchLoadingClass);
			triggerEvent(elem, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			try {
				elem.contentWindow.location.replace(src);
			} catch(e){
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

			if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesCfg.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
				src = elem[_getAttribute](lazySizesCfg.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				addClass(elem, lazySizesCfg.loadingClass);

				if(firesLoad){
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesCfg.lazyClass);

			rAF(function(){
				// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
				var isLoaded = elem.complete && elem.naturalWidth > 1;

				if( !firesLoad || isLoaded){
					if (isLoaded) {
						addClass(elem, 'ls-is-cached');
					}
					switchLoadingClass(event);
					elem._lazyCache = true;
					setTimeout(function(){
						if ('_lazyCache' in elem) {
							delete elem._lazyCache;
						}
					}, 9);
				}
				if (elem.loading == 'lazy') {
					isLoading--;
				}
			}, true);
		});

		var unveilElement = function (elem){
			if (elem._lazyRace) {return;}
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var afterScroll = debounce(function(){
			lazySizesCfg.loadMode = 3;
			throttledCheckElements();
		});

		var altLoadmodeScrollListner = function(){
			if(lazySizesCfg.loadMode == 3){
				lazySizesCfg.loadMode = 2;
			}
			afterScroll();
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}


			isCompleted = true;

			lazySizesCfg.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', altLoadmodeScrollListner, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement,
			_aLSL: altLoadmodeScrollListner,
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i && document.getElementsByClassName){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	setTimeout(function(){
		if(lazySizesCfg.init){
			init();
		}
	});

	lazysizes = {
		cfg: lazySizesCfg,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));


/***/ }),

/***/ "./node_modules/lazysizes/plugins/respimg/ls.respimg.js":
/***/ (function(module, exports, __webpack_require__) {

(function(window, factory) {
	if(!window) {return;}
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(__webpack_require__("./node_modules/lazysizes/lazysizes.js"));
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(typeof window != 'undefined' ?
	window : 0, function(window, document, lazySizes) {
	/*jshint eqnull:true */
	'use strict';
	var polyfill;
	var lazySizesCfg = lazySizes.cfg;
	var img = document.createElement('img');
	var supportSrcset = ('sizes' in img) && ('srcset' in img);
	var regHDesc = /\s+\d+h/g;
	var fixEdgeHDescriptor = (function(){
		var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
		var forEach = Array.prototype.forEach;

		return function(){
			var img = document.createElement('img');
			var removeHDescriptors = function(source){
				var ratio, match;
				var srcset = source.getAttribute(lazySizesCfg.srcsetAttr);
				if(srcset){
					if((match = srcset.match(regDescriptors))){
						if(match[2] == 'w'){
							ratio = match[1] / match[3];
						} else {
							ratio = match[3] / match[1];
						}

						if(ratio){
							source.setAttribute('data-aspectratio', ratio);
						}
						source.setAttribute(lazySizesCfg.srcsetAttr, srcset.replace(regHDesc, ''));
					}
				}
			};
			var handler = function(e){
				if(e.detail.instance != lazySizes){return;}
				var picture = e.target.parentNode;

				if(picture && picture.nodeName == 'PICTURE'){
					forEach.call(picture.getElementsByTagName('source'), removeHDescriptors);
				}
				removeHDescriptors(e.target);
			};

			var test = function(){
				if(!!img.currentSrc){
					document.removeEventListener('lazybeforeunveil', handler);
				}
			};

			document.addEventListener('lazybeforeunveil', handler);

			img.onload = test;
			img.onerror = test;

			img.srcset = 'data:,a 1w 1h';

			if(img.complete){
				test();
			}
		};
	})();

	if(!lazySizesCfg.supportsType){
		lazySizesCfg.supportsType = function(type/*, elem*/){
			return !type;
		};
	}

	if (window.HTMLPictureElement && supportSrcset) {
		if(!lazySizes.hasHDescriptorFix && document.msElementsFromPoint){
			lazySizes.hasHDescriptorFix = true;
			fixEdgeHDescriptor();
		}
		return;
	}

	if(window.picturefill || lazySizesCfg.pf){return;}

	lazySizesCfg.pf = function(options){
		var i, len;
		if(window.picturefill){return;}
		for(i = 0, len = options.elements.length; i < len; i++){
			polyfill(options.elements[i]);
		}
	};

	// partial polyfill
	polyfill = (function(){
		var ascendingSort = function( a, b ) {
			return a.w - b.w;
		};
		var regPxLength = /^\s*\d+\.*\d*px\s*$/;
		var reduceCandidate = function (srces) {
			var lowerCandidate, bonusFactor;
			var len = srces.length;
			var candidate = srces[len -1];
			var i = 0;

			for(i; i < len;i++){
				candidate = srces[i];
				candidate.d = candidate.w / srces.w;

				if(candidate.d >= srces.d){
					if(!candidate.cached && (lowerCandidate = srces[i - 1]) &&
						lowerCandidate.d > srces.d - (0.13 * Math.pow(srces.d, 2.2))){

						bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);

						if(lowerCandidate.cached) {
							lowerCandidate.d += 0.15 * bonusFactor;
						}

						if(lowerCandidate.d + ((candidate.d - srces.d) * bonusFactor) > srces.d){
							candidate = lowerCandidate;
						}
					}
					break;
				}
			}
			return candidate;
		};

		var parseWsrcset = (function(){
			var candidates;
			var regWCandidates = /(([^,\s].[^\s]+)\s+(\d+)w)/g;
			var regMultiple = /\s/;
			var addCandidate = function(match, candidate, url, wDescriptor){
				candidates.push({
					c: candidate,
					u: url,
					w: wDescriptor * 1
				});
			};

			return function(input){
				candidates = [];
				input = input.trim();
				input
					.replace(regHDesc, '')
					.replace(regWCandidates, addCandidate)
				;

				if(!candidates.length && input && !regMultiple.test(input)){
					candidates.push({
						c: input,
						u: input,
						w: 99
					});
				}

				return candidates;
			};
		})();

		var runMatchMedia = function(){
			if(runMatchMedia.init){return;}

			runMatchMedia.init = true;
			addEventListener('resize', (function(){
				var timer;
				var matchMediaElems = document.getElementsByClassName('lazymatchmedia');
				var run = function(){
					var i, len;
					for(i = 0, len = matchMediaElems.length; i < len; i++){
						polyfill(matchMediaElems[i]);
					}
				};

				return function(){
					clearTimeout(timer);
					timer = setTimeout(run, 66);
				};
			})());
		};

		var createSrcset = function(elem, isImage){
			var parsedSet;
			var srcSet = elem.getAttribute('srcset') || elem.getAttribute(lazySizesCfg.srcsetAttr);

			if(!srcSet && isImage){
				srcSet = !elem._lazypolyfill ?
					(elem.getAttribute(lazySizesCfg.srcAttr) || elem.getAttribute('src')) :
					elem._lazypolyfill._set
				;
			}

			if(!elem._lazypolyfill || elem._lazypolyfill._set != srcSet){

				parsedSet = parseWsrcset( srcSet || '' );
				if(isImage && elem.parentNode){
					parsedSet.isPicture = elem.parentNode.nodeName.toUpperCase() == 'PICTURE';

					if(parsedSet.isPicture){
						if(window.matchMedia){
							lazySizes.aC(elem, 'lazymatchmedia');
							runMatchMedia();
						}
					}
				}

				parsedSet._set = srcSet;
				Object.defineProperty(elem, '_lazypolyfill', {
					value: parsedSet,
					writable: true
				});
			}
		};

		var getX = function(elem){
			var dpr = window.devicePixelRatio || 1;
			var optimum = lazySizes.getX && lazySizes.getX(elem);
			return Math.min(optimum || dpr, 2.5, dpr);
		};

		var matchesMedia = function(media){
			if(window.matchMedia){
				matchesMedia = function(media){
					return !media || (matchMedia(media) || {}).matches;
				};
			} else {
				return !media;
			}

			return matchesMedia(media);
		};

		var getCandidate = function(elem){
			var sources, i, len, media, source, srces, src, width;

			source = elem;
			createSrcset(source, true);
			srces = source._lazypolyfill;

			if(srces.isPicture){
				for(i = 0, sources = elem.parentNode.getElementsByTagName('source'), len = sources.length; i < len; i++){
					if( lazySizesCfg.supportsType(sources[i].getAttribute('type'), elem) && matchesMedia( sources[i].getAttribute('media')) ){
						source = sources[i];
						createSrcset(source);
						srces = source._lazypolyfill;
						break;
					}
				}
			}

			if(srces.length > 1){
				width = source.getAttribute('sizes') || '';
				width = regPxLength.test(width) && parseInt(width, 10) || lazySizes.gW(elem, elem.parentNode);
				srces.d = getX(elem);
				if(!srces.src || !srces.w || srces.w < width){
					srces.w = width;
					src = reduceCandidate(srces.sort(ascendingSort));
					srces.src = src;
				} else {
					src = srces.src;
				}
			} else {
				src = srces[0];
			}

			return src;
		};

		var p = function(elem){
			if(supportSrcset && elem.parentNode && elem.parentNode.nodeName.toUpperCase() != 'PICTURE'){return;}
			var candidate = getCandidate(elem);

			if(candidate && candidate.u && elem._lazypolyfill.cur != candidate.u){
				elem._lazypolyfill.cur = candidate.u;
				candidate.cached = true;
				elem.setAttribute(lazySizesCfg.srcAttr, candidate.u);
				elem.setAttribute('src', candidate.u);
			}
		};

		p.parse = parseWsrcset;

		return p;
	})();

	if(lazySizesCfg.loadedClass && lazySizesCfg.loadingClass){
		(function(){
			var sels = [];
			['img[sizes$="px"][srcset].', 'picture > img:not([srcset]).'].forEach(function(sel){
				sels.push(sel + lazySizesCfg.loadedClass);
				sels.push(sel + lazySizesCfg.loadingClass);
			});
			lazySizesCfg.pf({
				elements: document.querySelectorAll(sels.join(', '))
			});
		})();

	}
}));


/***/ }),

/***/ "./src/js lazy recursive ^.*$":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./_form": [
		"./src/js/_form.js",
		"conditioner0"
	],
	"./_form.js": [
		"./src/js/_form.js",
		"conditioner0"
	],
	"./_polyfills": [
		"./src/js/_polyfills.js"
	],
	"./_polyfills.js": [
		"./src/js/_polyfills.js"
	],
	"./components/form": [
		"./src/js/components/form.js",
		"conditioner4"
	],
	"./components/form.js": [
		"./src/js/components/form.js",
		"conditioner4"
	],
	"./fetch": [
		"./src/js/fetch.js",
		"conditioner6"
	],
	"./fetch.js": [
		"./src/js/fetch.js",
		"conditioner6"
	],
	"./main": [
		"./src/js/main.js"
	],
	"./main.js": [
		"./src/js/main.js"
	],
	"./utils": [
		"./src/js/utils.js"
	],
	"./utils.js": [
		"./src/js/utils.js"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/js lazy recursive ^.*$";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "./src/js/_polyfills.js":
/***/ (function(module, exports) {

// import 'promise-polyfill/src/polyfill'

/***/ }),

/***/ "./src/js/main.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_js__ = __webpack_require__("./src/js/_polyfills.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__polyfills_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__("./src/js/utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lazysizes_plugins_respimg_ls_respimg__ = __webpack_require__("./node_modules/lazysizes/plugins/respimg/ls.respimg.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lazysizes_plugins_respimg_ls_respimg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lazysizes_plugins_respimg_ls_respimg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lazysizes__ = __webpack_require__("./node_modules/lazysizes/lazysizes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lazysizes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lazysizes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parallaxagency_conditioner__ = __webpack_require__("./node_modules/@parallaxagency/conditioner/dist/index.mjs");





// import 'lazysizes/plugins/parent-fit/ls.parent-fit.js'


// import 'focus-visible'



__WEBPACK_IMPORTED_MODULE_4__parallaxagency_conditioner__["a" /* default */].addPlugin({
  moduleSetName: function moduleSetName(name) {
    return './components/' + name + '.js';
  },
  moduleGetConstructor: function moduleGetConstructor(module) {
    return module.default;
  },
  moduleImport: function moduleImport(name) {
    return __webpack_require__("./src/js lazy recursive ^.*$")("" + name);
  }
});
__WEBPACK_IMPORTED_MODULE_4__parallaxagency_conditioner__["a" /* default */].addPlugin(__WEBPACK_IMPORTED_MODULE_4__parallaxagency_conditioner__["b" /* idle */]);
__WEBPACK_IMPORTED_MODULE_4__parallaxagency_conditioner__["a" /* default */].hydrate(document.documentElement);

var body = document.querySelector('body');
var nav = document.querySelector('nav');
var modal = document.querySelector('.modal');
var overlay = document.querySelector('.overlay');
var menu_toggles = document.querySelectorAll('.burger, .menu a');
var modal_toggles = document.querySelectorAll('.js-open-modal, .js-close-modal');
var scroll_to_buttons = document.querySelectorAll('.js-scroll-to');
var video = {};
var microlance = {};

function init() {
  var r = microlance;
  r.swatch_bg = document.querySelector('#color-picker');
  r.swatch_bg_text = document.querySelector('#color-picker .bg-text');
  r.swatches = document.querySelectorAll('.swatch');
  r.lance_images = document.querySelectorAll('.lance');

  for (var i = 0; i < r.swatches.length; ++i) {
    var s = r.swatches[i];
    s.addEventListener('click', on_swatch_click);
  }

  for (var i = 0; i < menu_toggles.length; ++i) {
    var t = menu_toggles[i];
    t.addEventListener('click', toggle_menu);
  }

  for (var i = 0; i < modal_toggles.length; ++i) {
    var t = modal_toggles[i];
    t.addEventListener('click', toggle_modal);
  }

  for (var i = 0; i < scroll_to_buttons.length; ++i) {
    var b = scroll_to_buttons[i];
    b.addEventListener('click', scrollTo);
  }

  video.container = document.querySelector('.video');
  video.player = document.querySelector('video');
  video.button = document.querySelector('.video .play');

  video.container.addEventListener('click', toggle_video);
  video.player.addEventListener('ended', toggle_video);

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        toggle_video({ type: 'click' });
        observer.disconnect();
      }
    });
  }, { rootMargin: '-400px' });

  observer.observe(video.player);

  overlay.addEventListener('click', close_interfaces);

  window.addEventListener('scroll', toggle_nav_contrast);
  toggle_nav_contrast();
}

function scrollTo(e) {
  e.preventDefault();

  var id = e.target.closest('.js-scroll-to').getAttribute('href').substr(1);

  if (id === '') {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_js__["scrollToPosition"])(0);
    return;
  }

  var $target = document.getElementById(id);
  Object(__WEBPACK_IMPORTED_MODULE_1__utils_js__["scrollToElement"])($target);
}

function toggle_nav_contrast(e) {
  if (window.scrollY > window.innerHeight / 4) {
    nav.classList.add('with-contrast');
  } else {
    nav.classList.remove('with-contrast');
  }
}

function toggle_menu(e) {
  if (body.classList.contains('menu-open')) {
    body.classList.remove('menu-open');
  } else {
    body.classList.add('menu-open');
    body.classList.remove('modal-open');
  }
}

function toggle_video(e) {
  switch (e.type) {
    case 'click':
      video.player.play();
      video.button.style.display = 'none';
      break;
    case 'ended':
      video.button.style.display = 'flex';
      break;
  }
}

function toggle_modal(e) {
  var content_id = e.target.getAttribute('data-article') || false;
  if (content_id) {
    var content = document.querySelector('template[data-article="' + content_id + '"]').innerHTML;
    modal.innerHTML = content;
    body.classList.add('modal-open');
  } else {
    body.classList.remove('modal-open');
  }
}

function close_interfaces(e) {
  body.classList.remove('modal-open', 'menu-open');
}

function on_swatch_click(e) {
  var r = microlance;
  var el = e.target;

  for (var i = 0; i < r.swatches.length; ++i) {
    r.swatches[i].classList.remove('active');
  }for (var i = 0; i < r.lance_images.length; ++i) {
    r.lance_images[i].classList.remove('active');
  }el.classList.add('active');

  var col = el.getAttribute('color');
  r.swatch_bg.setAttribute('color', col);

  switch (col) {
    case 'yellow':

      r.swatch_bg_text.innerHTML = 'YELLOW';
      r.lance_images[3].classList.add('active');

      break;
    case 'blue':

      r.swatch_bg_text.innerHTML = 'BLUE';
      r.lance_images[2].classList.add('active');

      break;
    case 'grey':

      r.swatch_bg_text.innerHTML = 'GREY';
      r.lance_images[1].classList.add('active');

      break;
    case 'orange':

      r.swatch_bg_text.innerHTML = 'ORANGE';
      r.lance_images[0].classList.add('active');

      break;
  }
}

window.addEventListener('load', init);

/***/ }),

/***/ "./src/js/utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getOffset"] = getOffset;
/* harmony export (immutable) */ __webpack_exports__["scrollToPosition"] = scrollToPosition;
/* harmony export (immutable) */ __webpack_exports__["scrollToElement"] = scrollToElement;
var $body = document.body;
var $header = document.getElementById('header');

function getOffset($el) {
  var align = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var bodyRect = $body.getBoundingClientRect();
  var elemRect = $el.getBoundingClientRect();
  var offset = elemRect.top - bodyRect.top;

  if (align === 'top') {
    offset = offset - 30;
  } else if (align === 'middle') {
    offset = offset - window.innerHeight / 2;
  }

  /* If we have a position: fixed header
  if ($header) {
    offset = offset - $header.getBoundingClientRect().height
  } */

  return offset;
}

function scrollToPosition(y) {
  var smooth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if ('scrollBehavior' in document.documentElement.style) {
    window.scrollTo({
      top: y - 69,
      left: 0,
      behavior: smooth ? 'smooth' : 'auto'
    });
  } else {
    window.scrollTo(0, y);
  }
}

function scrollToElement($el) {
  var smooth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var align = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'top';

  scrollToPosition(getOffset($el, align), smooth);
}

/***/ })

/******/ });


// WEBPACK FOOTER //
// main.cc2d29bd61ac9eabbc9d.js